var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcRemove(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#C1C1C1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.28553 4.78534C5.15293 4.78534 5.02575 4.83802 4.93198 4.93179C4.83821 5.02556 4.78553 5.15273 4.78553 5.28534C4.78553 5.41795 4.83821 5.54513 4.93198 5.6389L7.40685 8.11377L4.93198 10.5886C4.83821 10.6824 4.78553 10.8096 4.78553 10.9422C4.78553 11.0748 4.83821 11.202 4.93198 11.2958C5.02575 11.3895 5.15293 11.4422 5.28553 11.4422C5.41814 11.4422 5.54532 11.3895 5.63909 11.2958L8.11404 8.8208L10.589 11.2958C10.6828 11.3895 10.81 11.4422 10.9426 11.4422C11.0752 11.4422 11.2024 11.3895 11.2961 11.2958C11.3899 11.202 11.4426 11.0748 11.4426 10.9422C11.4426 10.8096 11.3899 10.6824 11.2961 10.5887L8.82124 8.1138L11.2961 5.63892C11.3899 5.54516 11.4426 5.41798 11.4426 5.28537C11.4426 5.15276 11.3899 5.02559 11.2961 4.93182C11.2024 4.83805 11.0752 4.78537 10.9426 4.78537C10.81 4.78537 10.6828 4.83805 10.589 4.93182L8.11406 7.40677L5.63909 4.93179C5.54532 4.83802 5.41814 4.78534 5.28553 4.78534Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRemove);
export default __webpack_public_path__ + "static/media/ic_remove.b8343a20.svg";
export { ForwardRef as ReactComponent };